<script>
export default {
  props: {
    to: { type: String, default: '' },
    name: { type: String, default: '' },
    icon: { type: String, default: '' },
    count: { type: String, default: '' },
    isChildMenuActive: { type: Boolean, default: false },
    openInNewPage: { type: Boolean, default: false },
  },
  computed: {
    isLucideLikeIcon() {
      return typeof this.icon === 'string' && this.icon.startsWith('i-');
    },
  },
};
</script>

<template>
  <router-link v-slot="{ href, isActive, navigate }" :to="to" custom>
    <a
      v-tooltip.right="$t(`SIDEBAR.${name}`)"
      :href="href"
      class="text-slate-100 dark:text-slate-100 background-item flex items-center justify-center rounded-lg hover:bg-item-hover dark:hover:bg-item-hover dark:hover:text-slate-100 hover:text-slate-100 relative"
      :class="{
        'bg-item-hover dark:background-item text-woot-25 hover:bg-woot-50':
          isActive || isChildMenuActive,
      }"
      :rel="openInNewPage ? 'noopener noreferrer nofollow' : undefined"
      :target="openInNewPage ? '_blank' : undefined"
      @click="navigate"
    >
      <span
        v-if="isLucideLikeIcon"
        :class="[
          icon,
          'nav-item-icon',
          {
            'text-woot-25': isActive || isChildMenuActive,
            'nav-item-icon--active': isActive || isChildMenuActive,
            'nav-item-icon--inactive': !isActive && !isChildMenuActive,
          },
        ]"
      />
      <fluent-icon
        v-else
        :icon="icon"
        class="nav-item-icon"
        :class="{
          'text-woot-25': isActive || isChildMenuActive,
          'nav-item-icon--active': isActive || isChildMenuActive,
          'nav-item-icon--inactive': !isActive && !isChildMenuActive,
        }"
      />
      <span class="sr-only">{{ name }}</span>
      <span
        v-if="count"
        class="absolute -right-0.5 -top-0.5 z-[1] flex min-h-[1.125rem] min-w-[1.125rem] items-center justify-center rounded-full bg-woot-500 px-1 text-[10px] font-bold leading-none text-white shadow-sm"
      >
        {{ count }}
      </span>
    </a>
  </router-link>
</template>

<style scoped>
.background-item {
  width: 39px;
  height: 39px;
  flex-shrink: 0;
  margin-bottom: 15px;
  margin-top: 15px;
}

.bg-item-hover {
  border-radius: 5px;
  background: #3cbeb6;
}

.nav-item-icon {
  width: 28px;
  height: 28px;
  flex-shrink: 0;
}

.nav-item-icon--inactive {
  width: 25px;
  height: 25px;
  color: #2d398e;
}

.nav-item-icon--active {
  width: 28px;
  height: 28px;
}
</style>
